import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="result-modal"
export default class extends Controller {
  connect() {
    const options = {backdrop: false, keyboard: true};
    this.modal = new Modal(this.element, options);
    this.modal.show();

    setTimeout(() => {
      this.modal.hide();
    }, 3000);
  }

  close(event) {
    this.modal.hide();
  }
}
